import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import PurchaseFormErrorMessage from '../common/forms/PurchaseFormErrorMessage';

export enum ErrorType {
  Blank = 'blank',
  Invalid = 'invalid',
  NotSupportValue = 'not_support_value',
  TooLong = 'too_long',
}

type InnerProps = InjectedIntlProps;

const BlankMessage: React.SFC<InnerProps> = ({ intl }) => (
  <PurchaseFormErrorMessage>
    {intl.formatMessage({
      id: `purchases.errors.customer.blank`,
      defaultMessage: intl.formatMessage({ id: 'purchases.errors.blank' }),
    })}
  </PurchaseFormErrorMessage>
);

const InvalidMessage: React.SFC<InnerProps> = ({ intl }) => (
  <PurchaseFormErrorMessage>
    {intl.formatMessage({
      id: `purchases.errors.customer.invalid`,
      defaultMessage: intl.formatMessage({
        id: 'purchases.errors.invalid',
      }),
    })}
  </PurchaseFormErrorMessage>
);

const NotSupportValueMessage: React.SFC<InnerProps> = ({ intl }) => (
  <PurchaseFormErrorMessage>
    {intl.formatMessage({
      id: `purchases.errors.customer.not_support_value`,
      defaultMessage: intl.formatMessage({
        id: 'purchases.errors.not_support_value',
      }),
    })}
  </PurchaseFormErrorMessage>
);

const TooLongMessage: React.SFC<InnerProps> = ({ intl }) => (
  <PurchaseFormErrorMessage>
    {intl.formatMessage({
      id: `purchases.errors.customer.too_long`,
      defaultMessage: intl.formatMessage({
        id: 'purchases.errors.too_long',
      }),
    })}
  </PurchaseFormErrorMessage>
);

const ERROR_COMPONENTS: {
  // tslint:disable-next-line:no-any
  [error in ErrorType]: React.ComponentClass;
} = {
  [ErrorType.Blank]: injectIntl(BlankMessage),
  [ErrorType.Invalid]: injectIntl(InvalidMessage),
  [ErrorType.NotSupportValue]: injectIntl(NotSupportValueMessage),
  [ErrorType.TooLong]: injectIntl(TooLongMessage),
};

interface Props {
  errors?: ErrorType[];
}

class ErrorMessage extends React.Component<Props> {
  public render() {
    const { errors } = this.props;
    if (!errors) {
      return null;
    }
    if (errors.length === 0) {
      return null;
    }
    return errors.map((error, index) => {
      const Component = ERROR_COMPONENTS[error];
      if (!Component) {
        return null;
      }
      return <Component key={index} />;
    });
  }
}

export default ErrorMessage;
